<table><tr>
  <td>
    <ngx-doc-form-filter-select *ngIf="!disabled" class="fullwidth" [options]="storeOptions" (valueChange)="selectChanged($event)" [placeholder]="placeholder"></ngx-doc-form-filter-select>
    <div *ngIf="!disabled" style="height:3px"></div>
    <ngx-doc-form-textarea class="fullwidth" [(value)]="value" [disabled]="disabled"></ngx-doc-form-textarea>
  </td>
  <td *ngIf="!disabled" style="width:3em;text-align:center;padding-left:0">
    <button class="nrk-doc-button" (click)="addStoreValue()">+</button>
    <button class="nrk-doc-button" (click)="removeStoreValue()">-</button>
  </td>
</tr></table>
